__turbopack_context__.v({
  "carouselImage": "Khz4La_carouselImage",
  "root": "Khz4La_root",
  "textContainer": "Khz4La_textContainer",
});
